var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGifOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.9 21 5V19ZM20 8.10695V5C20 4.45228 19.5477 4 19 4H5C4.45228 4 4 4.45228 4 5V19C4 19.5477 4.45228 20 5 20H19C19.5477 20 20 19.5477 20 19V9.19786H16.5703V11.5134H19.5611V12.5936H16.5703V15.893H15.279V8.10695H20ZM10.9102 11.8984V14.8824C10.6414 15.2496 10.2688 15.5276 9.79245 15.7166C9.31609 15.9055 8.7751 16 8.16945 16C7.54678 16 6.99558 15.8521 6.51582 15.5562C6.03606 15.2602 5.66604 14.8369 5.40575 14.2861C5.14546 13.7353 5.01021 13.0927 5 12.3583V11.7487C5 10.5722 5.2688 9.6533 5.8064 8.99198C6.344 8.33066 7.09424 8 8.05716 8C8.88398 8 9.54066 8.2139 10.0272 8.64171C10.5138 9.06952 10.8064 9.68627 10.9051 10.492H9.63933C9.49643 9.55436 8.97755 9.08556 8.08268 9.08556C7.50425 9.08556 7.06448 9.30392 6.76336 9.74064C6.46223 10.1774 6.30657 10.8182 6.29636 11.6631V12.262C6.29636 13.1034 6.46563 13.7567 6.80419 14.2219C7.14274 14.6872 7.61313 14.9198 8.21538 14.9198C8.87547 14.9198 9.34501 14.7629 9.62402 14.4492V12.9251H8.09289V11.8984H10.9102ZM13.6917 15.893V8.10695H12.4056V15.893H13.6917Z",
    fill: "white",
    fillOpacity: 0.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGifOff);
export default __webpack_public_path__ + "static/media/GIF_off.2b971fdb7a6f1a93a83f4365bce3749a.svg";
export { ForwardRef as ReactComponent };